export default __webpack_public_path__ + "static/networkProtection-b7cfe8f639e8b10d6de06c16deef97e2.png";